module.exports = __webpack_public_path__ + "img/20190731163127QQ截图20190731015949.35692a0a.png";